import axios from "axios";

const testURL = "/";
const baseURL = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? testURL : process.env.REACT_APP_PRODUCTION_URL;

const instance = axios.create({
  baseURL: baseURL
});

export default instance;



//http://localhost:8080/  <--- immetterlo per la chiamata